<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western6" id="calibre_toc_2">Chapter 1</h1>
<p class="western7">Brain spattered on asphalt doesn’t look very
much like anything at all, especially if the asphalt is new. Older
asphalt, gray and cracked from years in the sun, shows more of the
fatty gelatinous smear but leeches away much of the color.</p>
<p class="western7">Standing there in the late morning sun
outside the evacuated shell of what used to be one of the best
bakeries in town, I couldn’t help but feel a little sad. The
headless body on the ground didn’t feel anything at all. I strongly
suspect that the head, after I’d spread it over fifteen feet of
asphalt, didn’t feel anything either. I suppose that’s a good
thing.</p>
<p class="western7">Really, if the zombie still felt anything
after fighting with me, it would mean that I had not done my job
very well. It would also mean the zombie had won.</p>
<p class="western7">A zombie winning the fight means you die.</p>
<p class="western7">In my case, thankfully, dying would get me
out of his way. I’m an annoyance, rather than a possible food
source, and that might mean that my transition from this world to
the next would be somewhat uneventful. Depending on the personality
of the victor, it could as easily mean that my final moments would
be even more hideous than being eaten alive. An undead sadist is
still a sadist.</p>
<p class="western7">The world of “Kill or Be Killed” has only one
prize and only one type of fame. You’re the one still alive. Pat
yourself on the back!</p>
<p class="western7">I’ve been doing this gig, Freelance Zombie
Extermination, for just over a year and a half. My claim to fame is
simple: “Hey! I’m still alive!” Better, I’m sure, than the other
options.</p>
<p class="western7">The post-fatal menace that I had finished off
outside the old bakery had been harassing a small community of
squatters who had appropriated an office building two blocks away.
One of my previous satisfied customers had told them about me and
they had tracked me down, in the hopes that I’d be able to help
them out before anyone else was brutalized.</p>
<p class="western7">My profession is not one that pays well,
especially since the economy is mostly shot to Hell. All the same,
this pleasant group of people offered me a good barbequed chicken
lunch if I could make their unctuous bother disappear. Believe me,
I don’t usually work for so little, but they were quite kind and
polite. I really didn’t want to see them killed off one by one, so
we made an appointment for me to drop by on the most likely day
their local Trouble would be back and obnoxious. Apparently, he
liked to stick to a schedule.</p>
<p class="western7">I’m anal about being punctual and keeping
appointments, so two days later, I grabbed a few things after my
morning coffee and took a walk. Walking served a couple of
purposes. It gave me an opportunity to settle my thoughts and get
my Zen on. Perhaps, even more importantly, it was a chance to
survey the local landscape. The overall impression that I had, as
usual, was that we were much better off than a large portion of the
United States as a whole.</p>
<p class="western7">There is still a government, albeit at a
reduced level; the nation’s Capital needs to function. The city of
Arlington, Virginia, depending on where you’re standing, is within
five miles of Washington, DC. Many of the people who live out here
in the suburbs continue to commute into DC or work at companies
that were nationalized in order to keep everything afloat. We have
power more often than not, and even phone service. There are actual
stores and restaurants that are struggling to provide services,
unlike other parts of the country that look like Mad Max gone to
Hell.</p>
<p class="western7">All and all, it was a pretty enjoyable walk,
even if there were a lot of abandoned homes and businesses along
the way. Most of the inhabitants had fallen victim to the epidemic
in one way or another. My clients were squatters, but they had a
certain established feel to them because they’d been in that office
building for a goodly amount of time. They sounded like an
interesting group of people and I had hoped to talk to them for a
little bit after my hunt and reward luncheon, but that wasn’t how
it worked out.</p>
<p class="western7">At some point before my appointed time to
come around, their friendly neighborhood zombie killed every single
one of them. As near as I can tell, he got wind of my impending
arrival, and decided to show off his creativity. The cold-blooded
bastard did a brutal, methodical, and sadistic job of slaughtering
innocent people.</p>
<p class="western7">It wasn’t difficult to tell something was
wrong when I arrived that day. He’d left me a trail of bloody parts
to follow.</p>
<p class="western7">The job had changed from a paid gig into
revenge—nice, uninfected people should not be killed,
willy-nilly—it offends me on a primal level.</p>
<p class="western7">He was strong enough, smart enough, and far
cleverer than he needed to be. In other words, he was not easy to
kill, and he made the best of it by explaining to me everything
he’d done in Technicolor detail. When I finally got the drop on
him, I did not feel a single pang of remorse or twinge in my
conscience as I decapitated him. I will admit that I went a bit
overboard when I smashed his skull open.</p>
<p class="western7">I’m only human.</p>
<p class="western7">A few hours after being a complete scavenger,
rooting over the things the poor squatters no longer needed, I knew
I needed a break. Between the old bakery and my neighborhood,
alongside empty storefronts and a burnt-out McDonalds, was an
actual bar. Not just any bar, but a real, functioning drinking
establishment that was still serving customers. A beer at that bar
became the target of my desires, so I went forth.</p>
<p class="western7">It was barely a short walk, all things
considered, and before you can say, “asshole,” I was stepping
inside Marvin’s dystopian bar and grill. The owner and his wife
greeted me with their characteristic warmth, which is to say their
grunting was somewhat less bitter than what one would normally
receive. There was a beer on the bar in front of my customary
stool, so I knew the grunting was just for theatrical ambience.</p>
<p class="western7">No one has a beer waiting for you if they
don’t actually <i class="calibre4">like</i> you.</p>
<p class="western7">I was midway into my third beer when I
noticed a new face at the bar. Anyone you’d never seen before,
especially if they didn’t look like one of the undead, was cause
for pause. Being a gregarious soul, if a bit crusty around my rim,
I decided to engage him on my favorite topic.</p>
<p class="western7">“It’s like the whole Han Solo and Greedo
thing. People are still slapping around whether it was the virus or
zombies that showed up in the world first. They’ll be debating it
from now until... I guess, until human beings die out all the way,
or we don’t.” I locked eyes with him and attempted to draw him into
the conversation by force of will and two and a half beers.</p>
<p class="western7">“Regardless, there are zombies and there is a
virus. There has to be a relationship, because wherever one
appears, the other is soon to follow. Right? Some people are immune
to the virus, and they’re generally left alone by the zombies. If
you contract the virus, sure as the sun rises, you’re going to be
zombie chow.”</p>
<p class="western7">He stared back at me, this youngish scrawny
fellow. What he did not do, however, was hold up his end of the
conversational bargain. That’s the social exchange in which I give
you a piece of my mind and you give me a piece of yours back.</p>
<p class="western7">“You already know that the zombies will find
you. They’ll kill you. Killing someone their way generally involves
eating the liver and kidneys and sucking the blood out of the
victim’s arteries like a copper-flavored milkshake. At some point,
days or weeks later, the poor schlub will rise from whatever grave
he ended up in and join in the bloody festivities.” He just kept
looking at me, almost as though he didn’t speak any English, and he
made no move to agree, disagree, or shush me. Emboldened, I
continued.</p>
<p class="western7">“Now, say they get you... and with any luck,
I mean this from the bottom of my heart, someone will bash your
head in or set you on fire. One or the other would be sufficient,
but it never hurts to be sure. For my personal preference, head
bashing is best because you don’t have to cope with a
bacon-smelling fat candle that walks around, catching other things
on fire before it finally falls over.”</p>
<p class="western7">My brain rummaged around, grabbing at random
things, in hopes of making a cogent point. Your average, motivated
person could wreak all kinds of havoc on a zombie, and they’d do
their damnedest to keep coming. The only real way to stop it is the
classic way: destroy the cranium, pulverize the brain, and there
will be one less walking horror in the world. Why? The brain
appears to be the one thing the virus can’t or won’t regenerate
when someone dies the first time. It certainly won’t regenerate if
there’s nothing left to regenerate in the first place.</p>
<p class="western7">Anyone infected with the contagion will
reanimate when they die. But if their brain is not intact, all
you’re left with is a body in a coffin that can’t finish
regenerating because there’s no air for the body to breathe. Now,
if a brainless body manages to come back to life prior to being
interred, you have a critter that wants to hunt but can’t really
manage the proper sequence of movements.</p>
<p class="western7">All you have to do for them is round them up
and burn them. Easy. Their cousins that reanimated with their gray
matter intact, however, are a different story. Those have to be
killed in a much more active fashion because they’re willing and
able to fight back.</p>
<p class="western7">It would also be simpler, of course, if they
weren’t so personable.</p>
<p class="western7">I pulled myself out of the alcohol-induced
reverie, and addressed my companion.</p>
<p class="western7">“Dude, I can’t tell if you’re getting any of
this at all,” I waggled a finger at him while I contemplated beer
#3.</p>
<p class="western7">“Look, sit here with me in this dingy-ass
suburban cantina and imagine this scenario. And I mean ‘dingy’ in
the sweetest possible way, mind you! I think it will clue you into
what I’m talking about.” The owners nodded at me, but this dude
just kept staring like I had slugs using my nose for a love hotel.
I wasn’t going to let him win this game of civil inattention.</p>
<p class="western7">“All right, say: your little sister comes
back as a zombie. That’s tragic, and I’m very sorry for your loss.
Here’s the ‘but.’ The creature that used to be your hot Lolita of a
sibling still looks, talks, and acts very much like you would
expect her to.” I just kept right on going despite his lack of
response, working toward my degree in dramatic monologues...</p>
<p class="western7">“She still knows where you hid your porn.
That time at the carnival when you swallowed the goldfish she had
just won? She remembers that, too. You’ll find her memory has
crystal clarity and her mouth has no internal editor
whatsoever.</p>
<p class="western7">“Did I mention there’s no expression in her
eyes anymore, she’s got a deathly pallor, she’s incredibly strong,
and her cute little fingernails are four inches longer and about 20
times thicker than before?</p>
<p class="western7">“Oh. Sorry...</p>
<p class="western7">“Well, Little Heidi, who now remembers
everything down to the smallest detail thanks to the virus, as sure
as the sun will rise, is now coming after you because you’re
infected, too. She’s adorable, deadly, and will not stop until
she’s dined on your innards. Just to put the polish on that, she is
absolutely willing to do and say anything that comes to her ravaged
mind in order to manipulate you into being an easier target.</p>
<p class="western7">“Nice!</p>
<p class="western7">“‘Tommy! These evil zombies are defiling my
virginal, Aryan body! Ooo! Ack!,’ she might scream from beneath
your window some night.</p>
<p class="western7">“‘And I bet you’re up there yanking on your
gristle because it gets you so hot. You’re an evil, nasty big
brother. Come down here and show me how nasty you are! Heidi wants
your gooey drippings!’</p>
<p class="western7">“You’re looking a little pale around the
edges, my new friend. I didn’t hit the nail on the head by
accident, did I?” There was no way to know if I’d managed to pull
something true from the fabric of uncertainty. That being the case,
all I could figure was that my honesty was rippling around the
recesses of his heart and giving him a nasty case of gas. I
continued.</p>
<p class="western7">“You are so screwed! Take a few deep breaths.
That’s really the best thing you can do after someone has shared
horrible truths with you. Good. Good.</p>
<p class="western7">“I should tell you, if you manage to cripple
Little Heidi, you have to deliver the cootie grace as soon as you
can after that. The reason is pretty simple. She’s calling you
every name in the book, tossing every secret you’ve ever had around
as loud as she can, and is probably trying to seduce you at the
same time.</p>
<p class="western7">“After all, her brain is intact and she knows
every weakness you’ve got. I guarantee that she will exploit
everything in order to keep you from finishing her off, because she
has not lost sight of the original goal: kill my brother and eat
him. All she wants to do is stay alive, even if she’s been crippled
by your attempts to save your own life. She won’t heal super
quickly or anything like that, but at least she’ll be able to live
until she can hunt again.</p>
<p class="western7">“God forbid that you have this little
confrontation in public. Can you imagine how insane it would make
you to have to listen to that for any length of time or to see the
faces of other people as they listen to the litany of bizarre
excess spewing from her mouth while you delay in finishing her
off?</p>
<p class="western7">“Then again, it is possible that she’d take
another route entirely. She could scream in a high-pitched,
childlike voice. It’s classic and might even work. How long do you
want to listen to something like that?”</p>
<p class="western7">Apparently, he didn’t want to listen to that
at all, because he tossed his cookies all over the floor.</p>
<p class="western7">“That, my vomiting friend,” I said, giving
him a friendly pat on the shoulder, “is why you kill them as
quickly as you possibly can.”</p>
<p class="western7">I probably would have kept going even after
he upchucked because beer (for some reason known only to God) pulls
down the panties of my good sense. But Marvin, the bartender, gave
me an ugly look and a gentle suggestion.</p>
<p class="western7">“Frank, get the fuck out before I slap you
upside the head with a baseball bat.”</p>
<p class="western7">He didn’t get any sweeter when I gave him my
“you’ve wounded my heart” pout. I suppose that’s what you get from
someone who used to be your landlord. Truth be told, that’s
probably why I didn’t hang out in his place very often. He’s a good
soul, but we’d shared some really fucked up times together.</p>
<p class="western7">I got up and walked outside. A reasonable
number of Coronas and being the bearer of bad news ruins the
comfortable environment of any local watering hole. With any luck,
Marvin and Shirley will let me come back in a few days. You have to
let the memory of some things fade a little bit, but they know I
will tell anyone and everyone The Way Things Are at the drop of a
hat. Blunt, cynical commentary is a dying art.</p>
<p class="western7">Then again, I’m a wonderful customer to have,
and that goes for any establishment. I pay my bill virtually every
time, and I am always willing to take out a pesky zombie. Zombies,
on the other hand, do not pay, ever, and tend to murder your
clients in the most unfortunate ways.</p>
<p class="western7">I do have a certain gentle abrasiveness about
me, but I like to think that is part of my overall personal charm.
Then, like the Lolita Zombie Sister, I also have a tendency to say
exactly what is on my mind without considering the possible
consequences. Happily, no one to date has decided that it merited
killing me, in or out of bars and restaurants.</p>
<p class="western7">My reputation for being Johnny-On-The-Spot
for Undead Pest Removal does a lot to overcome my quirks in public
places. No one wants a zombie farting around in their establishment
if they can possibly avoid it. It isn’t just the murdering and
feasting—there’s also the smell. The walking dead do not, as a
rule, give a flying politician whether or not they’ve bathed since
they came back from the Big Quiet.</p>
<p class="western7">Zombies call death “the Big Quiet.” Some say
they remember dying, the parts after the explosive agony of being
eaten alive and bleeding out. They say there’s nothing there, Out
There, and that there is just this big quiet blackness that
swallows you. If you can believe the walking dead have a religion,
this is as close as it gets.</p>
<p class="western7">The scripture would be short.</p>
<p class="western7">“In the beginning, there was life and it was
a random pattern of good events and bad events. In the middle,
there was dying in a very nasty way, assisted by unfortunate mobs
of undead cannibals. At the end of the middle came Death. Death was
big, silent, and black. In the end, there is life after Death. That
will also be nasty, because you have to eat your fellow man to stay
alive.”</p>
<p class="western7">Like I said, a very short scripture. Their
idea of a worship service probably wouldn’t be all that wonderful,
if you consider that the only thing that really gets them going is
eating people.</p>
<h1 class="western8">
</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_f099aff482e799492a35054ee1867e1f_WrMliK.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue?307573db